module.exports = __webpack_public_path__ + "static/world-2c1b23ac3ccf009c9853f042ea336ccf.svg";